import { Component, OnInit, HostListener } from "@angular/core";
import { ApiService } from "../services/api.service";
import { CartService } from "../services/cart.service";
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: "vm-list",
    templateUrl: "./checkout-vm.component.html",
    //styleUrls: ['../../assets/sass/checkout.scss']
})
export class CheckoutVMComponent implements OnInit {
    preselectedConfigurationTypeUuid = null;
    preselectedConfigurationUuid = null;
    menu;
    filtersModel = {};
    filtersActive = {};
    filters = [];
    products = [];
    configurationGroups = [];
    configurations = [];
    additionalStorages = [];
    operatingSystemTypes = [];
    additionalServices = [];
    selectedAdditionalDisks = [];
    selectedAdditionalDisk = {};
    selectedAdditionalServices = [];
    selectedAdditionalStorageDiskType = { uuid: null, name: null };
    selectedAdditionalStorages = [];
    selectedOperatingSystem = {
        uuid: '',
        netto: 0,
        type: {
            name: ''
        }
    };
    checkoutCartItems = [];
    processorsSelected = 1;
    ramSelected = 1;
    speedSelected = 1;
    selectedConfigurationType = {};
    selectedConfiguration = {
        configurable: false,
        disk_size: {},
        default_os: {},
        netto: 0,
        ram_size_per_step_netto: 0,
        processor_per_step_netto: 0,
        min_processor_count: 0,
        processors: 0,
        max_processor_count: 0,
        min_ram_size: 0,
        ram_size: 0,
        max_ram_size: 0,
        processor_step: 0,
        ram_size_step: 0,
        public_network_speed_per_step_netto: 0,
        min_public_network_speed: 0,
        public_network_speed_step: 0,

    };
    nettoSum = 0;
    nettoPerSelectedProcessors = 0;
    nettoPerSelectedRamSize = 0;
    nettoPerSelectedAdditionalDisks = 0;
    nettoPerSelectedAdditionalServices = 0;
    nettoPerSelectedSpeed = 0;

    constructor(
        private apiService: ApiService,
        private cartService: CartService,
        private notificationService: NotificationsService,
        private trans: TranslateService,
        private route: ActivatedRoute,


    ) {
        this.route.queryParams.subscribe(params => {
            this.preselectedConfigurationTypeUuid = params['type_uuid'] || null;
            this.preselectedConfigurationUuid = params['uuid'] || null;
            console.log('Type UUID:' + this.preselectedConfigurationTypeUuid);
            console.log('UUID:' + this.preselectedConfigurationUuid);
        });

        
        if(this.preselectedConfigurationUuid && this.preselectedConfigurationTypeUuid){
            this.loadOffers(this.preselectedConfigurationTypeUuid, this.preselectedConfigurationUuid);
        }else{
            this.clearSelections();
        }
    }

    // @HostListener('window:resize', ['$event'])
    // onResize(event) {
    //     if (event.target.innerWidth < 990) {
    //         this.menu.style.width = '0';
    //         return;
    //     }
    //     this.menu.style.width = '200px';
    // }

    ngOnInit() {
        // this.menu = document.getElementById('sidebar');
        // if (window.innerWidth < 990) {
        //     this.menu.style.width = '0';
        // }
    }

    loadOffers(preselectConfigruationType = null, preselectConfigruation = null){
        this.apiService.get('/offer/vm').subscribe(response => {
            this.configurationGroups = response.configurationGroups;
            this.selectedConfigurationType = response.selectedConfigurationType;
            this.configurations = response.configurations;
            this.operatingSystemTypes = response.operatingSystemTypes;
            this.additionalServices = response.additionalServices;
            if(preselectConfigruationType && preselectConfigruation){
                this.configurationGroups.forEach(configurationGroup => {
                    let preselect = configurationGroup.configuration_types.find(configurationType => configurationType.uuid === preselectConfigruationType);
                    if(preselect){
                        this.selectedConfigurationType = preselect;
                    }
                });

                this.loadConfigurations(this.selectedConfigurationType, null, preselectConfigruation);
            }
        });
    }

    loadConfigurations(configurationType, event, selectConfiguration = null, selectConfigruationType = null) {
        this.selectedConfigurationType = configurationType;
        this.apiService.get('/offer/vm/' + configurationType.uuid).subscribe(response => {
            this.configurations = response.configurations;
            if(selectConfiguration){
                let selectedConfiguration  = this.configurations.find(configuration => configuration.uuid === selectConfiguration);
                this.selectConfiguration(selectedConfiguration, null);
            }
        });
    }

    selectConfiguration(configuration, event) {
        this.selectedConfiguration = configuration;
        this.apiService.get('/offer/vm/configuration/' + configuration.uuid).subscribe(response => {
            this.processorsSelected = response.configuration.processors;
            this.ramSelected = response.configuration.ram_size;
            this.operatingSystemTypes = response.operatingSystemTypes;
            this.additionalServices = response.additionalServices;
            this.speedSelected = response.configuration.public_network_speed;
            this.nettoPerSelectedProcessors = this.selectedConfiguration.processor_per_step_netto * (this.selectedConfiguration.processors - this.selectedConfiguration.min_processor_count);
            this.nettoPerSelectedRamSize = this.selectedConfiguration.ram_size_per_step_netto * (this.selectedConfiguration.ram_size - this.selectedConfiguration.min_ram_size);
            this.selectedOperatingSystem = response.default_os;
            this.selectedAdditionalDisk = response.default_disk;
            this.additionalStorages = response.additionalStorages;
        });
        this.nettoPerSelectedAdditionalServices = 0;
        this.nettoPerSelectedAdditionalDisks = 0;
        this.selectedAdditionalServices = [];
        this.selectedAdditionalDisks = [];
        this.selectedAdditionalStorages = [];
        this.selectedAdditionalStorageDiskType = { uuid: null, name: null };
    }

    setProcessors(value) {
        this.processorsSelected = value;
        this.nettoPerSelectedProcessors = this.selectedConfiguration.processor_per_step_netto * ((this.processorsSelected - this.selectedConfiguration.min_processor_count)/this.selectedConfiguration.processor_step);
    }

    setRam(value) {
        this.ramSelected = value;
        this.nettoPerSelectedRamSize = this.selectedConfiguration.ram_size_per_step_netto * ((this.ramSelected - this.selectedConfiguration.min_ram_size)/this.selectedConfiguration.ram_size_step);
    }

    setSpeed(value) {
        this.speedSelected = value;
        this.nettoPerSelectedSpeed = this.selectedConfiguration.public_network_speed_per_step_netto * ((this.speedSelected - this.selectedConfiguration.min_public_network_speed)/this.selectedConfiguration.public_network_speed_step);
    }

    setAdditionalDisk(additionalDisk) {
        this.selectedConfiguration.disk_size = additionalDisk;
        this.nettoPerSelectedAdditionalDisks = additionalDisk.netto;
    }

    setAdditionalService(additionalService) {
        if(this.selectedConfiguration.processors == 0){
            this.notificationService.info('Błąd!', 'Nie wybrano konfiguracji!');
            this.clearSelections();
            return ;
        }
        this.selectedAdditionalServices.push(additionalService);
        this.nettoPerSelectedAdditionalServices += additionalService.netto;
    }

    setOperatingSystem(operatingSystem) {
        if(this.selectedConfiguration.processors == 0){
            this.notificationService.info('Błąd!', 'Nie wybrano konfiguracji!');
            this.clearSelections();
            return ;
        }
        this.selectedOperatingSystem = operatingSystem;
    }

    clearSelections() {
        // @todo clear any selections
        this.selectedConfiguration = {
            configurable: false,
            disk_size: {},
            default_os: {},
            netto: 0,
            ram_size_per_step_netto: 0,
            processor_per_step_netto: 0,
            min_processor_count: 0,
            processors: 0,
            max_processor_count: 0,
            min_ram_size: 0,
            ram_size: 0,
            max_ram_size: 0,
            processor_step: 0,
            ram_size_step: 0,
            public_network_speed_per_step_netto: 0,
            min_public_network_speed: 0,
            public_network_speed_step: 0,
        };
        this.selectedAdditionalDisks = [];
        this.selectedAdditionalServices = [];
        this.selectedOperatingSystem = {
            uuid: '',
            netto: 0,
            type: {
                name: ''
            }
        };
        this.speedSelected = 0;
        this.ramSelected = 0;
        this.processorsSelected = 0;
        this.nettoPerSelectedProcessors = 0;
        this.nettoPerSelectedRamSize = 0;
        this.nettoPerSelectedSpeed = 0;
        this.nettoPerSelectedAdditionalDisks = 0;
        this.nettoPerSelectedAdditionalServices = 0;
        this.selectedAdditionalStorageDiskType = { uuid: null, name: null };
        this.selectedAdditionalStorages = [];
        this.loadOffers();
    }

    addToCart() {
        if(this.selectedConfiguration.processors == 0){
            this.notificationService.info('Błąd!', 'Nie wybrano konfiguracji');
            window.scrollTo(0, 0);
            return ;
        }
        let currentSelections = {
            'configuration': this.selectedConfiguration,
            'processors': this.processorsSelected,
            'ram': this.ramSelected,
            'public_network_speed': this.speedSelected,
            'default_disk': this.selectedConfiguration.disk_size,
            'selected_os': this.selectedOperatingSystem,
            'additional_disks': this.selectedAdditionalDisks,
            'additional_services': this.selectedAdditionalServices,
            'additional_storages': this.selectedAdditionalStorages,
            'netto': this.selectedConfiguration.netto,
        };
        // @todo push selectedadditionaldisks
        // @todo push additional disk drives
        // @todo insert selected os by user
        // @todo insert additional Services
        // @todo calculate netto sum for currentSelections
        currentSelections.netto += this.nettoPerSelectedRamSize;
        currentSelections.netto += this.nettoPerSelectedProcessors;
        currentSelections.netto += this.nettoPerSelectedAdditionalDisks;
        currentSelections.netto += this.nettoPerSelectedAdditionalServices;
        currentSelections.netto += this.nettoPerSelectedSpeed;
        // currentSelections.netto += currentSelections.selected_os.netto;
        currentSelections.additional_storages.forEach((element, index, array) => {
            currentSelections.netto += element.netto;
        });

        this.checkoutCartItems.push(currentSelections);
        this.nettoSum += currentSelections.netto;
        this.clearSelections();
        window.scrollTo(0, 0);
    }

    removeCartItem(cartItem) {
        const index: number = this.checkoutCartItems.indexOf(cartItem);
        if (index !== -1) {
            this.nettoSum -= parseFloat(cartItem.netto);
            this.checkoutCartItems.splice(index, 1);
        }
    }

    addAdditionalStorage() {
        if(this.selectedConfiguration.processors == 0){
            this.notificationService.info('Błąd!', 'Nie wybrano konfiguracji!');
            return ;
        }
        if(this.additionalStorages.length == 0){
            this.notificationService.info('Błąd!', 'Wybrana linia nie posiada dodatkowych przestrzeni!');
            return ;
        }
        if(this.selectedAdditionalStorageDiskType.uuid == null)
        {
            this.notificationService.info('Błąd!', 'Proszę wybrać typ dodatkowej przestrzeni!');
            return ;
        }
        this.selectedAdditionalStorages.push({ diskType: this.selectedAdditionalStorageDiskType, value: 0, netto: 0 });
    }

    setAdditionalStorageDiskType(diskType) {
        this.selectedAdditionalStorageDiskType = diskType;
    }

    setAdditionalStorageValue(selectedAdditionalStorage, event) {
        selectedAdditionalStorage.netto = (event / selectedAdditionalStorage.diskType.pivot.step) * selectedAdditionalStorage.diskType.pivot.netto_per_step;
        selectedAdditionalStorage.value = event;
    }

    addItemsToCart() {
        if(this.checkoutCartItems.length == 0){
            this.notificationService.info('Błąd!', 'Nie wybrano produktów!');
            return ;
        }
        this.cartService.storeCartVPSs(this.checkoutCartItems);
    }
}


// WEBPACK FOOTER //
// ./src/app/checkout/checkout-vm.component.ts